import { createMutationHook } from '~/shared/providers/api';

export interface AddUsersToRoleMutationParams {
  roleId: string;
  facilityId: string;
  userIds: string[];
}

export interface AddUsersToRoleMutationResult {
  successCount: number;
  failedCount: number;
  failedIds: string[];
}

export const useAddUsersToRoleMutation = createMutationHook(
  'settings.teamPermissions.addUsersToRole',
  (params: AddUsersToRoleMutationParams) => ({
    coreRoleAddUsers: {
      __args: {
        input: {
          roleId: params.roleId,
          facilityId: params.facilityId,
          userIds: params.userIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
);
